export const buildProfessionalSchema = ({ siteName, description, url }) => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": siteName,
  "description": description,
  "url": url,
  "areaServed": "Twin Cities Metro",
  "serviceType": "Digital Architecture"
});

export const buildCreativeWorkSchema = ({ title, description, authorName, url, image }) => ({
  "@context": "https://schema.org",
  "@type": "CreativeWork",
  "name": title,
  "description": description,
  "author": {
    "@type": "Person",
    "name": authorName
  },
  "url": url,
  "image": image
});
